import React from 'react';

import { Checkbox as CheckboxPure } from 'twyne-new.ui';

const propTypes = {
};

export default function Checkbox({ children, value, wrapClassName, ...props }) {
  return <div className={`flex items-center gap-1 ${wrapClassName || ''}`}>
    <CheckboxPure
      value={value}
      {...props}
    />
    {children}
  </div>
}

Checkbox.propTypes = propTypes
Checkbox.defaultProps = {}
